import { IonIcon, IonText } from "@ionic/react"

import './TitleText.css'

interface Props {
    icon: any
}

const TitleText: React.FC<Props> = (props) => {
    return (
        <IonText className="title-text">
            <IonIcon icon={props.icon} />
            {props.children}
        </IonText>
    )
}

export default TitleText